import AxiosService from '@/services/AxiosService'

export default {
    /**
     * Get list Flux on period
     *
     * @param routeParams
     * @returns {*}
     */
    getMedals(routeParams)
    {
        return AxiosService.callApi().get('/podium?date=' + routeParams.date  + '&center=' + routeParams.center +'&category=' + routeParams.category)
    },
}
